<div class="c-card">
	<div class="c-content u-no-p@up-to-md">
		<table-created-training-program [(programs)]="vm.programs" [trainingProgramCode]="vm.trainingProgramCode" [pageSize]="vm.pageSize" [(currentPage)]="vm.currentPage" (currentPageChange)="vm.currentPageChanged($event)"></table-created-training-program>
	</div>
	<div *ngIf="vm.programs && vm.programs?.length > vm.pageSize">
		<div class="o-grid u-ost-md u-osb-md">
			<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
				<list-pager [totalItems]="vm.programs?.length" [pageSize]="vm.pageSize" [(currentPage)]="vm.currentPage" (currentPageChange)="vm.currentPageChanged($event)"></list-pager>
			</div>
		</div>
	</div>
</div>
